import moment from "moment";

export default function datetime(date) {
    return moment(date)
        .add(Config.timezone, 'h')
        .format('YYYY-MM-DD HH:mm:ss');
}